import React, { useEffect, useCallback } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Page, FilesDropzone, Header, Alert, SelectField } from 'components';
import { enqueueSnackbar } from 'actions';
import { Card, CardContent,	TextField, Grid, Button, colors } from '@mui/material';
import _ from 'underscore';
import useRouter from 'utils/useRouter';

import ModalDialog from '../../../../../components/ModalDialog/ModalDialog.js';
import IncidentTrackerDialogForm from './IncidentTrackerDialogForm';

import { SetFormState, ToggleIncidentTrackerDialog, CreateIncident, EditIncident,
	UploadFilesAndCreateIncident, UploadFilesAndEditIncident } from '../../../actions/IncidentTrackerActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 960,
	},
	header: {
		padding: theme.spacing(3),
		maxWidth: 720,
		margin: '0 auto',
	},
	content: {
		padding: theme.spacing(0, 2),
		maxWidth: 720,
		margin: '0 auto',
	},
	helperText: {
		textAlign: 'right',
		marginRight: 0,
	},
	author: {
		margin: theme.spacing(4, 0),
		display: 'flex',
	},
	avatar: {
		marginRight: theme.spacing(2),
	},
	actions: {
		backgroundColor: colors.grey[100],
		padding: theme.spacing(2),
		display: 'flex',
		alignContent: 'right',
	},
	applyButton: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const IncidentTrackerDialog = (props) => {
	const classes = useStyles();
	const { onClose, open, incidentId, submitter, ...rest } = props;
	const dispatch = useDispatch();
	const title = incidentId !== 0 ? 'Edit incident' : 'Create incident';
	const confirmLabel = incidentId !== 0 ? 'Edit' : 'Create';
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.incidentTrackerReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const files = useSelector((state) => state.incidentTrackerReducer.files);
	const image = useSelector((state) => state.incidentTrackerReducer.image);

	const _onConfirmClick = () => {
		setFormState({ ...formState, submit: true });
		const uploadFiles = [...files, image];

		if (formState.isValid && incidentId === 0) {
			if (uploadFiles[0].size > 0) {
				dispatch(UploadFilesAndCreateIncident({ ...formState.values, submitter: userId }, uploadFiles));
			} else {
				dispatch(CreateIncident({ ...formState.values, submitter: userId }));
			}
			dispatch(ToggleIncidentTrackerDialog(false, 0));
		} else if (formState.isValid) {
			if (uploadFiles[0].size > 0) {
				dispatch(UploadFilesAndEditIncident({ ...formState.values, editingUser: userId }, uploadFiles));
			} else {
				dispatch(EditIncident({ ...formState.values, editingUser: userId }));
			}
			dispatch(ToggleIncidentTrackerDialog(false, 0));
		}
	};

	return (
		<ModalDialog
			onClose={onClose}
			title={title}
			open={open}
			confirmLabel={confirmLabel}
			onConfirmClicked={_onConfirmClick}
			maxWidth="xl"
		>
			<IncidentTrackerDialogForm incidentId={incidentId} submitter={submitter} />
		</ModalDialog>
	);
};

IncidentTrackerDialog.propTypes = {
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
	incidentId: PropTypes.number,
	submitter: PropTypes.string
};

export default IncidentTrackerDialog;
